
const svg = '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" role="img"><path fill-rule="evenodd" clip-rule="evenodd" d="M11 10.1716V19.6391L13 19.3057V10.1716L19.1716 4H4.82843L11 10.1716ZM2 4V2H22V4L15 11V21L9 22V11L2 4Z" fill="currentColor"></path></svg>';export default svg;
    